import {
  CategoryScale,
  Chart as ChartJS,
  type ChartOptions,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import type React from 'react';
import { useId, useMemo } from 'react';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

export interface LineChartProps {
  labels: string[];
  data: number[];
  options?: ChartOptions<'line'>;
  height?: number;
}

const defaultOptions: ChartOptions<'line'> = {
  plugins: { legend: { display: false } },
  scales: {
    x: {
      ticks: { font: { size: 10 } },
      grid: { display: false },
    },
    y: { grid: { color: '#eee' }, beginAtZero: true, ticks: { stepSize: 1 } },
  },
  responsive: true,
  maintainAspectRatio: false,
};

const DynamicLineChart: React.FC<LineChartProps> = ({ labels, data, options, height = 120 }) => {
  const chartId = useId();
  const chartKey = useMemo(() => JSON.stringify({ labels, data }), [labels, data]);
  return (
    <Line
      key={chartKey}
      id={chartId}
      data={{
        labels,
        datasets: [
          {
            data,
            borderColor: '#10B981',
            backgroundColor: 'rgba(16,185,129,0.1)',
            tension: 0.4,
            pointRadius: 4,
            pointBackgroundColor: '#fff',
            pointBorderColor: '#10B981',
            fill: false,
          },
        ],
      }}
      options={{
        ...defaultOptions,
        ...options,
        scales: {
          ...defaultOptions.scales,
          ...(options?.scales || {}),
        },
        plugins: {
          ...defaultOptions.plugins,
          ...(options?.plugins || {}),
        },
      }}
      height={height}
    />
  );
};

export default DynamicLineChart;
